import { buttonVariants } from "@nt/ui/recipes";
import { useState } from "react";

import { authPost } from "@/lib/api";
import type { Session } from "@/lib/queries";
import { AuthCard, AuthSplit } from "@/pages/sign-in";

type NoticeState = "pending" | "none" | "closed";

const NOTICE_COPY: Record<
  NoticeState,
  { title: string; body: string; next: string | null }
> = {
  pending: {
    title: "Your application is under review",
    body: "We review applications by hand and email you at the address you applied with. You do not need to do anything else.",
    next: null,
  },
  none: {
    title: "There is no partner account for this email",
    body: "Apply at nonresident.tax/partnership, or sign out and sign in with the email you applied with.",
    next: "https://nonresident.tax/partnership",
  },
  closed: {
    title: "This partner account is closed",
    body: "You can no longer use the portal. If you think this is a mistake, write to support@nonresident.tax.",
    next: null,
  },
};

export function Notice({
  state,
  email,
}: {
  state: Session["state"];
  email: string;
}) {
  const copy = NOTICE_COPY[state as NoticeState] ?? NOTICE_COPY.none;
  const [leaving, setLeaving] = useState(false);
  return (
    <AuthSplit>
      <AuthCard title={copy.title} description={copy.body}>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-muted-foreground">
            Signed in as{" "}
            <span className="font-medium text-foreground">{email}</span>.
          </p>
          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              disabled={leaving}
              className={buttonVariants({
                variant: copy.next ? "secondary" : "primary",
              })}
              onClick={() => {
                setLeaving(true);
                void authPost("sign-out", {}).finally(() =>
                  window.location.assign("/"),
                );
              }}
            >
              {leaving ? "Signing out…" : "Sign out"}
            </button>
            {copy.next ? (
              <a className={buttonVariants()} href={copy.next}>
                Apply to the program
              </a>
            ) : null}
          </div>
        </div>
      </AuthCard>
    </AuthSplit>
  );
}
